module.exports = __webpack_public_path__ + "img/ico-ygx.7c985bac.png";